module.exports = __webpack_public_path__ + "static/media/cmp-logo.93987846.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cmp-logo.svg
// module id = 149
// module chunks = 0